import { unisportDiscount } from '../../discounts';

export const da = {
      GetDiscount: `Få ${unisportDiscount} rabat fra vejledende pris ved at tilføje Unisport som sponsor på trøjerne.`,
      AddUnisport: 'Rabatten kan ikke kombineres med andre rabatkoder.',
      Customise: 'Personalisér',
      AddClublogo: 'Tilføj klublogo',
      RepresentClub: 'Med klubben i hjertet! ',
      AddSponsorLogo: 'Tilføj sponsorlogo',
      sponsorshipText: 'Ny sponsoraftale?',
      AddPlayername: 'Tilføj spillernavn',
      ChooseBelow: 'Vælges nedenfor',
      AddPlayerNumber: 'Tilføj spillernummer',
      note: 'Bemærk: Hvis du vælger klub/sponsorlogo til mindre end 5 sæt, og ikke har en eksisterende klubaftale, vil der blive opkrævet et opstartsgebyr på 400,- som vil specificeres, når vores kundeservice kontakter dig inden for 1 arbejdsdag',
      pcs: '/stk',
    };

export const nb = {
    GetDiscount: `Få ${unisportDiscount} rabatt av veiledende pris`,
    AddUnisport: 'Legg til Unisport-sponsorlogo på draktene',
    Customise: 'Personaliser',
    AddClublogo: 'Legg til klubblogo',
    RepresentClub: 'Med klubben i hjertet!',
    AddSponsorLogo: 'Legg til sponsorlogo',
    sponsorshipText: 'Ny sponsoravtale?',
    AddPlayername: 'Legg til spillernavn',
    ChooseBelow: 'Velg nedenfor',
    AddPlayerNumber: 'Legg til spillernummer',
    note: 'OBS: Hvis du velger klubblogo og har valgt et lavere antall sett enn 5, og ikke har en eksisterende klubbavtale, så vil det bli oppkrevet et oppstartsgebyr. Dette oppstartsgebyret vil bli spesifisert når kundeservice kontakter deg i løpet av 1 arbeidsdag.',
    pcs: '/stk',
};

export const fi = {
    GetDiscount: `Hyödynnä ${unisportDiscount} alennus ovh-hinnoista.`,
    AddUnisport: 'Lisää Unisport-logo paitaan',
    Customise: 'Yksilöinti',
    AddClublogo: 'Lisää seuralogo',
    RepresentClub: 'Edusta seuraasi ylpeydellä',
    AddSponsorLogo: 'Lisää sponsorilogo',
    sponsorshipText: 'Uusi sponsoridiili?',
    AddPlayername: 'Lisää pelaajan nimi',
    ChooseBelow: 'Valitse alta',
    AddPlayerNumber: 'Lisää pelaajan numero',
    note: 'HUOM: Jos valitset seuralogopainatuksen ja olet valinnut painatettuja tuotteita vähemmän kuin 5 kpl - olet velvollinen maksamaan painatukseen sisältyvän aloitusmaksun. Aloitusmaksu täsmentyy, kun asiakaspalvelumme on sinuun yhteydessä yhden(1) arkipäivän kuluessa. ',
    pcs: '/kpl',
};

export const sv = {
    GetDiscount: `Få ${unisportDiscount} rabatt på vägledande pris`,
    AddUnisport: 'Lägg till Unisport sponsor-logo på tröjorna',
    Customise: 'Personalisera',
    AddClublogo: 'Lägg till klubb-logo',
    RepresentClub: 'Visa upp klubbemblemet!',
    AddSponsorLogo: 'Lägg till sponsor-logo',
    sponsorshipText: 'Nytt sponsoravtal?',
    AddPlayername: 'Lägg till spelarnamn',
    ChooseBelow: 'Välj nedan',
    AddPlayerNumber: 'Lägg till spelarnummer',
    note: 'OBS: Klubb- eller sponsor-logo kan ej väljas om du beställer färre än 5 matchställ.',
    pcs: '/st.',
};

export const at = {
    GetDiscount: `Bekomme ${unisportDiscount} Rabatt auf die UVP`,
    AddUnisport: 'Füge das Unisport-Sponsorenlogo hinzu',
    Customise: 'Personalisieren',
    AddClublogo: 'Vereinslogo hinzufügen',
    RepresentClub: 'Zeig deine Farben!',
    AddSponsorLogo: 'Sponsorenlogo hinzufügen',
    sponsorshipText: 'Neuer Sponsorenvertrag?',
    AddPlayername: 'Spielernamen hinzufügen',
    ChooseBelow: 'Unten wählen',
    AddPlayerNumber: 'Spielernummer hinzufügen',
    note: 'Beachte: Wenn du ein Vereinslogo als Druck wählst und weniger als 5 Sets bestellst, kommt eine Startgebühr zur Gesamtsumme hinzu, die dir innerhalb von 1 Arbeitstag von unserem Kundenservice mitgeteilt werden wird.',
    pcs: '/Stck.',
};

export const de = {
    GetDiscount: `Bekomme ${unisportDiscount} Rabatt auf die UVP`,
    AddUnisport: 'Füge das Unisport-Sponsorenlogo hinzu',
    Customise: 'Personalisieren',
    AddClublogo: 'Vereinslogo hinzufügen',
    RepresentClub: 'Zeig deine Farben!',
    AddSponsorLogo: 'Sponsorenlogo hinzufügen',
    sponsorshipText: 'Neuer Sponsorenvertrag?',
    AddPlayername: 'Spielernamen hinzufügen',
    ChooseBelow: 'Unten wählen',
    AddPlayerNumber: 'Spielernummer hinzufügen',
    note: 'Beachte: Wenn du ein Vereinslogo als Druck wählst und weniger als 5 Sets bestellst, kommt eine Startgebühr zur Gesamtsumme hinzu, die dir innerhalb von 1 Arbeitstag von unserem Kundenservice mitgeteilt werden wird.',
    pcs: '/Stck.',
};

export const fr = {
    GetDiscount: `Obtenez -${unisportDiscount} de réduction sur le prix public.`,
    AddUnisport: 'Ajouter le logo Unisport au maillot',
    Customise: 'Personnaliser',
    AddClublogo: 'Ajouter le logo du club',
    RepresentClub: 'représentez votre club avec honneur',
    AddSponsorLogo: 'Ajouter le logo du sponsor',
    sponsorshipText: 'Nouveau partenariat de sponsoring?',
    AddPlayername: 'Ajouter le nom du joueur',
    ChooseBelow: 'Choisir ci-dessous',
    AddPlayerNumber: 'Ajouter le numéro du joueur',
    note: 'Note: si vous choisissez de personnaliser avec un, ou plusieurs logos, mais que vous avez choisis une quantité de moins de 5 tenues, vous devrez vous acquitter du coût de création des logos. Ce coût vous sera spécifié par notre service client après avoir passé la commande.',
    pcs: '/unité',
};

export const nl = {
    GetDiscount: `Ontvang ${unisportDiscount} korting op de originele adviesprijs`,
    AddUnisport: 'Voeg het Unisport sponsorlogo toe aan de shirts',
    Customise: 'Personaliseer',
    AddClublogo: 'Voeg een clublogo toe',
    RepresentClub: 'Vertegenwoordig je club met trots',
    AddSponsorLogo: 'Voeg een sponsorlogo toe',
    sponsorshipText: 'Nieuwe sponsordeal?',
    AddPlayername: 'Voeg spelersnaam toe',
    ChooseBelow: 'Kies hieronder',
    AddPlayerNumber: 'Voeg rugnummer toe',
    note: 'Let op: als je aangeeft dat je een clublogo wilt laten bedrukken en een hoeveelheid van minder dan 5 hebt gekozen, dan worden hiervoor extra kosten gerekend. Deze kosten worden gecommuniceerd zodra onze klantenservice contact met je opneemt.',
    pcs: '/p st.',
};

export const en = {
    GetDiscount: `Get ${unisportDiscount} Discount, from RRP`,
    AddUnisport: 'Add Unisport sponsor logo to shirt',
    Customise: 'Customise',
    AddClublogo: 'Add Club logo',
    RepresentClub: 'Represent your club with pride',
    AddSponsorLogo: 'Add Sponsor Logo',
    sponsorshipText: 'New sponsorship deal?',
    AddPlayername: 'Add Player name',
    ChooseBelow: 'Choose below',
    AddPlayerNumber: 'Add Player number',
    note: 'Note: If you select to have club logo printed, and you have picked less than 5 amount - you are liable to pay a startup fee for the printing. This startup fee will be specified, when contacted by Customer Service. ',
    pcs: '/pcs.',
};
